import React, {useState, useEffect} from 'react'
import Nav from '../components/BrainzShop/Nav.js'
import BrainzShopPage from '../components/BrainzShop/BrainzShop.js'
import { currentConnectedAddress, isMetaMaskInstalled, requestAccounts, getPendingBrainz, claimBrainz, balanceOf, tokenOfOwner} from '../Contract/Web3Client'

const BrainzShop = () => {
  const { ethereum } = window
  const [page, setPage] = useState("Reroll")
  const [walletAddress, setWalletAddress] = useState('')
  const [navButtonText, setNavButtonText] = useState('Connect Wallet')
  const [tokens, setTokens] = useState([])
  const [pendingBrainz, setPendingBrainz] = useState(0)

  useEffect(() => {
    getCurrentConnectedWallet()
    addWalletListener()
  }, [])

  useEffect(() => {
    getTokens()
    loadPendingBrainz()
  }, [walletAddress])

  useEffect(() => {
    setButtonText()
  }, [pendingBrainz])

  const toggleShop = (page) => {
    console.log("In toggle: " + page)
    setPage(page)
  }

  const setButtonText = () => {
    if(walletAddress.length === 0) {
      setNavButtonText('Connect Wallet')
    } else {
      setNavButtonText('Claim ' + pendingBrainz + ' $BRAINZ')
    }
  }

  const getTokens = () => {
    balanceOf(walletAddress).then(bal => {
      tokenOfOwner(walletAddress, bal).then(t => {
        setTokens(t)
      })
    }).catch(err => {
      console.log(err)
    })
  }

  const loadPendingBrainz = () => {
    getPendingBrainz(walletAddress).then(pb => {
      setPendingBrainz(pb)
    });
  }

  const getCurrentConnectedWallet = async () => {
    if(isMetaMaskInstalled()){
      try {
        const addressArray = await currentConnectedAddress()
        if(addressArray.length > 0) {
          setWalletAddress(addressArray[0])
          setNavButtonText('Loading $BRAINZ...')
        }
      } catch (error) {
        console.log(error)
      }
    } 
  }

  const addWalletListener = () => {
    if(isMetaMaskInstalled()){
      ethereum.on('accountsChanged', (accounts) => {
        if(accounts.length > 0) {
          setWalletAddress(accounts[0])
        } else {
          setWalletAddress('')
          setNavButtonText('Connect Wallet')
        }
      })
    }
  }

  const buttonOnClick = async () => {
    if(walletAddress.length === 0){
      try {
        const addressArray = await requestAccounts()
        setWalletAddress(addressArray[0])
        setNavButtonText('Loading $BRAINZ...')
      } catch (error) {
        console.log(error)
      }
    }
    claimBrainz(walletAddress)
  }

  return (
    <>
      <Nav
        toggleShop={toggleShop}
        address={walletAddress}
        buttonOnClick={buttonOnClick}
        buttonText={navButtonText}
      />
      <BrainzShopPage 
        page={page}
        address={walletAddress}
        tokens={tokens}
      />
    </>
  )
}

export default BrainzShop
